var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#70b246;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grass_2",
    "data-name": "grass 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,639.06c24.17-36,67.19-51.69,103.87-39.7,40.68,13.31,54.49,54.48,55.91,59,16.06-29.54,49.74-42.81,77.67-33,21.55,7.55,37.23,28,40.65,52.28,16.85-30.3,49.46-47.67,82.24-44,41.58,4.63,61.8,40.69,63.6,44a100.51,100.51,0,0,1,101.81,0C543.35,625,587,586.34,638.56,578.52c64.86-9.83,132,30.78,156.84,99.06,17-37.51,55.3-59.65,93.55-55,49.31,5.94,70.66,53,71.55,55,2.91-3.88,18.73-24.18,46.77-27.52,37.67-4.48,62,25.85,63.29,27.52-1-38.07,27.89-70.1,64-73.09,33.29-2.76,65,19.87,73.63,53.83,7.5-12.64,41.6-67,110.21-85.3,100.15-26.74,178.18,48.8,181.65,52.28V1080H0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects14);
export default __webpack_public_path__ + "static/media/objects-14.aad760f3eaf9afb170b486007d01259f.svg";
export { ForwardRef as ReactComponent };